import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthDialogData } from './auth-dialog-data';

@Component({
    selector: 'odq-auth-dialog',
    template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
      <p>{{ data.message }}</p>
      @if (isSafari) {
        <h4>
          <mat-icon color="warn" style="margin-right: 4px; vertical-align: middle;">warning</mat-icon>
          <span [innerHTML]="'error.auth.sessionFailure.safariHint' | translate" style="font-size: initial"></span>
        </h4>
        @if (isSafariMac) {
          <p [innerHTML]="'error.auth.sessionFailure.safariMacInstructions' | translate"></p>
        }
        @if (isSafariIos) {
          <p [innerHTML]="'error.auth.sessionFailure.safariIosInstructions' | translate"></p>
        }
      }
    </div>
    <div mat-dialog-actions align="end">
      <button color="primary" mat-button (click)="onCancel()" type="button">{{ data.cancelText }}</button>
      <button color="primary" mat-raised-button (click)="onOk()" type="button">{{ data.okText }}</button>
    </div>
    `,
    styles: [`.cdk-overlay-container .mat-mdc-dialog-container { padding: 24px; }`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AuthSessionFailureDialogComponent implements OnInit {
  isSafari: boolean;
  isSafariIos: boolean;
  isSafariMac: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AuthDialogData,
    public dialogRef: MatDialogRef<AuthSessionFailureDialogComponent>,
  ) {
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.isSafariIos =
      this.isSafari &&
      (/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
    this.isSafariMac = this.isSafari && window.screen.availWidth >= 1200;
  }

  ngOnInit() { }

  onCancel() {
    this.dialogRef.close(false);
  }

  onOk() {
    this.dialogRef.close(true);
  }
}
